/**
 * Text constants for messages and errors
 *
 * @author Mamontov Andrey, 04/2018
 */
export class AppMessages {

  /**
   * Common
   */
  public static readonly APP_TITLE_SUCCESS = 'Поздравляю!';
  public static readonly APP_TITLE_FAIL = 'Уппс...';
  public static readonly DATA_LOAD_SUCCESS = 'Данные успешно загружены';
  public static readonly DATA_LOAD_FAIL = 'Ошибка загрузки данных';
  public static readonly ITEM_NAME_EXISTS = 'Выбранное имя не уникально. Выберите другое имя.';
  public static readonly LOAD_ONE_FAIL = 'Ошибка загрузки объекта';

  public static readonly APP_SAVE_SUCCESS = 'Объект успешно сохранен!';
  public static readonly APP_SAVE_ERROR = 'Ошибка сохранения объкта';
  public static readonly APP_REMOVE_SUCCESS = 'Объект успешно удален';
  public static readonly APP_REMOVE_ERROR = 'Ошибка удаления объкта';

  /*
   * Reception
   */
  public static readonly COMPLAINT_FORWARD_SUCCESS = 'Обращение успешно перенаправлено';
  public static readonly COMPLAINT_FORWARD_SUCCESS_ALL = 'Обращения успешно перенаправлены';
  public static readonly COMPLAINT_FORWARD_ERROR = 'Ошибка отправки обращения';
  public static readonly COMPLAINT_FORWARD_ERROR_ALL = 'Ошибка отправки обращений';
  public static readonly COMPLAINT_PRINT_REQUEST_SUCCESS = 'Запрос на печать успешно направлен';
  public static readonly COMPLAINT_PRINT_REQUEST_PERFORMED = 'Файлы для печати сформированы успешно';
  public static readonly COMPLAINT_PRINT_REQUEST_ERROR = 'Ошибка отправки запроса на печать';




  /**
   * User
   */
  public static readonly USER_LOGIN_FAIL = 'Ошибка авторизации пользователя. Проверьте логин или пароль.';

}
